


















































































































import { computed, defineComponent, ref, useRouter } from '@nuxtjs/composition-api'
import { useAutocomplete, useConfig } from '~/composables';
import SearchModal from './SearchModal.vue';
import Teleport from 'vue2-teleport';
import ClientOnly from 'vue-client-only';
import { openSearchTrack, suggestionLinkTrack, sendSearchTrack } from '~/helpers/trackings/24orepro/search';
import { findSuggestedCorrectTerm } from '~/utils/helpers/search';
import { AUTOCOMPLETE_MIN_CHARS } from '~/utils/constants/code';

export default defineComponent({
    name: "SearchBar",
    components: {
        SearchModal,
        ClientOnly,
        Teleport
    },
    data() {
        return {
            buttonRef: null,
            isSearchOpen: false,
        }
    },
    mounted() {
        if (process.client) {
            const elements = document.querySelectorAll(`[id^="searchSuggestionsButton"]`);
            this.buttonRef = elements[0];
        }
    },
    setup(props) {
        const queryTerm = ref<string>('')
        const { loadSuggestedTermsResults, resetSuggestedTerms, suggestedTerms } = useAutocomplete();
        const router = useRouter();
        const updateRoute = (term) => router.push(`${term}`)
        const { config: storeConfig } = useConfig();
        const fuzzySuggestion = computed(() => {
            if (queryTerm.value.length <= AUTOCOMPLETE_MIN_CHARS) return null;
            return findSuggestedCorrectTerm(queryTerm.value);
        })
        return {
            queryTerm,
            fuzzySuggestion,
            loadSuggestedTermsResults,
            resetSuggestedTerms,
            suggestedTerms,
            updateRoute,
            storeCode: storeConfig.value.store_code
        }
    },
    computed: {
        hasSuggestions() {
            //@ts-ignore
            return this.suggestedTerms.length > 0 || !!this.fuzzySuggestion;
        }
    },
    methods: {
        async getAutocompleteValues() {
            //@ts-ignore
            return this.queryTerm.length >= AUTOCOMPLETE_MIN_CHARS ? this.loadSuggestedTermsResults(this.queryTerm, undefined, this.fuzzySuggestion) : this.resetSuggestedTerms();
        },
        openSearch() {
            this.isSearchOpen = true;
            openSearchTrack()
        },
        sendSearch(callback = null) {
            //@ts-ignore
            this.updateRoute(`/${this.storeCode}/search/${encodeURIComponent(this.queryTerm)}`)
            sendSearchTrack(this.queryTerm);
            //@ts-ignore
            this.closeSearch(callback);
        },
        handleSuggested(val) {
            this.queryTerm = val;
            //@ts-ignore
            this.sendSearch()
            suggestionLinkTrack(val);
        },
        closeSearch(cleanupCallback = null) {
            this.isSearchOpen = false;
            this.queryTerm = '';
            //@ts-ignore
            this.resetSuggestedTerms();
            
            // Clean mobile modal with accessibility functions.
            if (cleanupCallback) {
                cleanupCallback();
            }
        }
    }
})

